import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { createAnalytics, checkAiBuddyUserDetails } from './AnalyticsApi';

export interface IAnalytics {
  userId?: string;
  type: string;
  data: Record<string, unknown>;
}

export interface IAnalyticsState {
  status: 'idle' | 'loading' | 'rejected';
  checkStatus: 'idle' | 'loading' | 'fulfilled' | 'rejected';
  hasSubmittedForm: boolean | null;
  userDetailsData: any[] | null;
}

const initialState: IAnalyticsState = {
  status: 'idle',
  checkStatus: 'idle',
  hasSubmittedForm: null,
  userDetailsData: null,
};

export const AnalyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAnalytics.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createAnalytics.fulfilled, (state) => {
        state.status = 'idle';
      })
      .addCase(createAnalytics.rejected, (state) => {
        state.status = 'rejected';
      })
      .addCase(checkAiBuddyUserDetails.pending, (state) => {
        state.checkStatus = 'loading';
      })
      .addCase(checkAiBuddyUserDetails.fulfilled, (state, action) => {
        state.checkStatus = 'fulfilled';
        state.userDetailsData = action.payload;
        state.hasSubmittedForm =
          Array.isArray(action.payload) && action.payload.length > 0;
      })
      .addCase(checkAiBuddyUserDetails.rejected, (state) => {
        state.checkStatus = 'rejected';
        state.hasSubmittedForm = null;
      });
  },
});

export const getAnalyticsState = (state: RootState): RootState['analytics'] =>
  state.analytics;

export * from './AnalyticsApi';
export default AnalyticsSlice.reducer;
